var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('video',{style:(_vm.computedStyle),attrs:{"src":_vm._source,"poster":_vm._preview,"controls":_vm._showControls,"autoplay":_vm._autoPlay},domProps:{"muted":_vm._muted}})}
var staticRenderFns = []

export { render, staticRenderFns }